import { FC } from "react";
import { HorizontalStack } from "../../Stack";
import DocumentTrackCard from "./DocumentTrackCard";
import PdfTrackCard from "./PdfTrackCard";

const DocumentWithPDF: FC<any> = (props) => {
  return (
    <HorizontalStack>
      {props.doc.fileType !== "pdf" && (
        <DocumentTrackCard
          modal="share"
          setSelectedDocuments={props.setSelectedDocuments}
          documentWithTrack={props.doc}
          setDocumentWithTrack={props.setDocumentWithTrackChanges}
          length={props.size}
        />
      )}
      {props.doc.fileType === "pdf" && (
        <PdfTrackCard
          modal="share"
          setSelectedDocuments={props.setSelectedDocuments}
          documentWithTrack={props.doc}
          setDocumentWithTrack={props.setDocumentWithTrackChanges}
          length={props.size}
        />
      )}
      {props.doc.includePdf && ( // this is the attachment card
        <PdfTrackCard
          modal="share"
          setSelectedDocuments={props.setSelectedDocuments}
          documentWithTrack={props.doc}
          setDocumentWithTrack={props.setDocumentWithTrackChanges}
          length={props.size}
        />
      )}
    </HorizontalStack>
  );
};

export default DocumentWithPDF;
